export default __webpack_public_path__ + "static/media/739.fb385666.jpg";